
import React from 'react';
import { Link } from 'react-router-dom';

// Category styling for top/bottom/versatile
const CATEGORY_STYLES = {
    top: { bg: 'bg-wine-500/8', text: 'text-wine-300/80', border: 'border-wine-500/15', label: 'Top' },
    bottom: { bg: 'bg-purple-500/8', text: 'text-purple-300/80', border: 'border-purple-500/15', label: 'Bottom' },
    versatile: { bg: 'bg-amber-500/8', text: 'text-amber-300/80', border: 'border-amber-500/15', label: 'Versatile' },
};

const DEFAULT_STYLE = { bg: 'bg-dark-800', text: 'text-dark-300', border: 'border-dark-700', label: '' };

const ArchetypeCard = ({ archetype }) => {
    const { id, name, category, summary } = archetype;

    const style = CATEGORY_STYLES[category] || DEFAULT_STYLE;

    // Clean summary: take only the first sentence before any pipe separator
    const cleanSummary = summary
        ? summary.split('|')[0].trim()
        : '—';

    return (
        <Link to={`/archetype/${id}`} className="block group">
            <div className={`
                relative overflow-hidden
                bg-dark-900/50 border ${style.border}
                rounded-xl p-4 h-full
                transition-all duration-200
                hover:bg-dark-800/60 hover:border-wine-500/30
                hover:-translate-y-0.5
            `}>
                {/* Header Row */}
                <div className="flex items-start gap-3 mb-3">
                    <div className="flex-1 min-w-0">
                        <h3 className="text-base font-semibold text-dark-100 group-hover:text-wine-400 transition-colors truncate">
                            {name}
                        </h3>
                    </div>
                </div>

                {/* Summary */}
                <p className="text-sm text-dark-400 leading-relaxed line-clamp-3">
                    {cleanSummary}
                </p>
            </div>
        </Link>
    );
};

export default ArchetypeCard;
